import { computed, type Ref } from 'vue';
import type { Author } from '@models/author.ts';
import type { AccountManager } from '@models/accountManager.ts';
import type { UUIDv4 } from '@global-types/uuid.ts';

// eslint-disable-next-line import/prefer-default-export
export const useAuthor = (user: Ref<Author | AccountManager>) => {
  const pictureUrl = computed<string | undefined>(() => ('picture_url' in user.value ? user.value.picture_url : undefined));

  const mediaUuid = computed<UUIDv4 | undefined>(() => ('profile_picture' in user.value ? user.value.profile_picture?.uuid : undefined));

  const isAccountManager = computed<boolean>(() => 'picture_url' in user.value);

  return {
    pictureUrl,
    mediaUuid,
    isAccountManager,
  };
};
